import PageNotFound from '../pages/404/PageNotFound';
import InternalServerError from '../pages/500/InternalServerError';
import Dashboard from '../pages/dashboard/DashboardPage';
import RegistrationsLayout from '../pages/registrations/RegistrationsLayout';
import FormPreviewPage from '../pages/registrations/preview/FormPreviewPage';
import PaymentAccountsPage from '../pages/paymentAccounts/PaymentAccountsPage';
import ReportsListPage from '../pages/reports/ReportsListPage';
import ReportsPage from '../pages/reports/ReportsPage';
import SavedReportsPage from '../pages/reports/SavedReportsPage';
import PaymentOptionsPage from '../pages/settings/payment-options/PaymentOptions';
import Organization from '../pages/organization/OrganizationPage';
import UsersPage from '../pages/users/UsersPage';
import NotificationsPage from '../pages/notifications/NotificationsPage';

export type RouteType = {
  path?: string;
  component: React.FC<any>;
  back?: string;
};

export type RouteTypes = {
  [key: string]: RouteType;
};

const userRoutes: RouteTypes = {
  Dashboard: { path: '/dashboard', component: Dashboard },
  Report: { path: '/reports/:formId/:reportId', component: ReportsPage, back: 'SavedReports' },
  CreateReport: { path: '/reports/:formId/create', component: ReportsPage, back: 'SavedReports' },
  SavedReports: { path: '/reports/:formId/', component: SavedReportsPage, back: 'Reports' },
  Reports: { path: '/reports', component: ReportsListPage },
  Registrations: { path: '/registrations', component: RegistrationsLayout },
  Submission: {
    path: '/registrations/submissions/:formId/:submissionId',
    component: RegistrationsLayout,
    back: 'Submissions',
  },
  Submissions: { path: '/registrations/submissions/:formId', component: RegistrationsLayout, back: 'Registrations' },
  CreateForm: { path: '/registrations/admin/create-new-form', component: RegistrationsLayout, back: 'Registrations' },
  EditForm: { path: '/registrations/admin/edit-form/:formId', component: RegistrationsLayout, back: 'Registrations' },
  Draggable: { path: '/registrations/draggable', component: RegistrationsLayout, back: 'Registrations' },
  Preview: { path: '/registrations/preview/:formId', component: FormPreviewPage, back: 'Registrations' },
  Users: { path: '/users/', component: UsersPage },
  PaymentAccounts: { path: '/payment-accounts', component: PaymentAccountsPage },
  Notifications: { path: '/notifications', component: NotificationsPage, back: 'Registrations' },
  PaymentOptions: { path: '/settings/payment-options', component: PaymentOptionsPage },
  Error: { path: '/500', component: InternalServerError },
  Organization: { path: '/organization', component: Organization },
  PageNotFound: { component: PageNotFound },
};

export { userRoutes };
